import axios from "axios";
import cilinderItems from "@/store/modules/cilinderItems";
import hoseItems from "@/store/modules/hose/hoseItems";
import motorConfigItems from "@/store/modules/motor/motorItems";

export default {
    namespaced: true,
    state: {
        isCartOpen: false,
        cartItems: [],
        currentOrder: null,
    },
    modules: {
        cilinderItems,
        hoseItems,
        motorConfigItems,
    },
    getters: {
        getAll(state) {
            return [...state.cartItems, ...cilinderItems.state.all, ...hoseItems.state.all, ...motorConfigItems.state.all];
        },
        getCurrentOrder(state) {
            return state.currentOrder;
        },
        isCartOpen(state) {
            return state.isCartOpen;
        }
    },
    mutations: {
        init(state) {
            let cart = localStorage.getItem('cart_data');
            cart = JSON.parse(cart);

            if (cart) {
                state.cartItems = cart.cartItems;
                state.cilinderItems.all = cart.cilinderItems ? cart.cilinderItems.all : [];
                state.hoseItems.all = cart.hoseItems ? cart.hoseItems.all : [];
                state.motorConfigItems.all = cart.motorConfigItems ? cart.motorConfigItems.all : [];
            }
        },
        setCartState(state, payload) {
            state.isCartOpen = payload;
        },
        setCartItems(state, order) {
            let item = state.cartItems.find((item) => {
                return item.build === order.build;
            });

            if (item) {
                item.amount += 1;
            } else {
                state.cartItems.push(order);
            }

            // save cart for refresh
            localStorage.setItem('cart_data', JSON.stringify(state));
        },
        setCurrentOrder(state, order) {
            state.currentOrder = order;
        },
        setItemAmount(state, payload) {
            let item = state.cartItems.find((item) => {
                return item.build === payload.build;
            });
            if (payload.newAmount === 0) {
                const confirmed = confirm('Weet u zeker dat u deze powerpack uit uw systeem wilt halen?');
                if (confirmed) {
                    state.cartItems = state.cartItems.filter((item) => {
                        return item.build !== payload.build;
                    });
                }
            } else {
                item.amount = payload.newAmount;
            }

            localStorage.setItem('cart_data', JSON.stringify(state));
        },
    },
    actions: {
        addPowerpackMagentoOrder({rootGetters, dispatch}) {
            const buildObject = rootGetters['build/getBuildObject'];

            return axios.post(
                process.env.VUE_APP_API_URL + 'cart/getMagentoPowerpackOrder',
                {
                    build: buildObject,
                    locale: rootGetters['preference/getLocale']
                }).then((response) => {
                const build = response.data.build;
                const data = {
                    products: response.data.products,
                    build_id: build.uid,
                    build_type: 'powerpack'
                }

                return dispatch('sendToMagentoCart', {data, build}).then((res) => {
                    return res;
                }).catch((error) => {
                    throw error;
                })
            });
        },

        addHoseMagentoOrder({rootGetters, dispatch}) {
            const buildObject = rootGetters['build/hoses/getBuildObject'];
            const buildExtras = rootGetters['build/hoses/getHoseExtras'];

            return axios.post(
                process.env.VUE_APP_API_URL + 'cart/getMagentoHoseOrder',
                {
                    build: buildObject,
                    build_extras: buildExtras,
                    locale: rootGetters['preference/getLocale']
                }).then((response) => {
                const build = response.data.build;
                const data = {
                    products: response.data.products,
                    build_id: build.uid,
                    build_type: "hose"
                }

                return dispatch('sendToMagentoCart', {data, build}).then((res) => {
                    return res;
                }).catch((error) => {
                    throw error;
                })
            });
        },

        sendToMagentoCart({dispatch}, payload) {
            const baseUrl = window.location.origin;

            const axiosConfig = {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                },
            }

            function addExtraProductCall(sku) {
                const products = {
                    [sku]: 1
                }

                calls.push(axios.post(
                    baseUrl + '/add-product-to-cart',
                    {
                        build_id: null,
                        build_type: null,
                        products: products
                    },
                    axiosConfig
                ))
            }

            const calls = [addHoseProduct]

            const addHoseProduct = axios.post(
                baseUrl + '/add-product-to-cart',
                payload.data,
                axiosConfig
            )

            let price = payload.build.price;
            const extraProducts = [];

            if (payload.build.hose_label) {
                addExtraProductCall(payload.build.hose_label.sku);

                extraProducts.push({
                    name: payload.build.hose_label.description,
                })

                price += 500;
            }

            if (payload.build.test_certificate) {
                addExtraProductCall(payload.build.test_certificate.sku);

                extraProducts.push({
                    name: payload.build.test_certificate.description,
                    price: 0,
                })
            }

            return Promise.all(calls).then(() => {
                dispatch('refreshMagentoCart');

                return {
                    name: payload.build.name,
                    description: payload.build.description,
                    price: price,
                    extraProducts: extraProducts,
                    amount: 1
                };
            })
        },

        addOrder({rootGetters, commit}) {
            const buildObject = rootGetters['build/getBuildObject'];
            return axios.post(process.env.VUE_APP_API_URL + 'powerpack/builds/make', {build: buildObject, locale: rootGetters['preference/getLocale']})
                .then((response) => {
                    const order = {
                        type: 'powerpack',
                        build: response.data.buildId,
                        name: response.data.name,
                        description: response.data.description,
                        price: response.data.price,
                        uid: response.data.uid,
                        amount: 1
                    };
                    commit('setCartItems', order);
                    commit('setCartState', true);
                });
        },

        getBuildId({rootGetters}) {
            const buildObject = rootGetters['build/getBuildObject'];
            return axios.post(process.env.VUE_APP_API_URL + 'powerpack/builds/make', {build: buildObject, locale: rootGetters['preference/getLocale']})
                .then((response) => {
                    return response.data.uid;
                });
        },

        sendOrder({state}) {
            const powerpacks = state.cartItems.map((s) => {
                return {
                    build: s.build,
                    amount: s.amount,
                }
            });

            axios.post(process.env.VUE_APP_API_URL + 'cart/sendToCcv', {
                powerpacks: powerpacks,
                cilinders: cilinderItems.state.all,
                hoses: state.hoseItems.all,
                motorConfigs: motorConfigItems.state.all,
            })
                .then(({data}) => {
                    if (!data) return;
                    const shopPopup = window.open(data, '_self');

                    if (!shopPopup || shopPopup.closed || typeof shopPopup.closed == 'undefined') {
                        window.location = data;
                    }
                });
        },

        refreshMagentoCart({}) {
            if (typeof window.require === 'function') {
                window.require(
                    ['Magento_Customer/js/customer-data'],
                    function (customerData) {
                        const sections = ['cart'];
                        customerData.invalidate(sections);
                        customerData.reload(sections, true);
                    }
                );
            }
        },
        setCartLocalStorage({state}) {
            localStorage.setItem('cart_data', JSON.stringify(state));
        }
    }
}
